export default {
  SELECTED_DEVICE: 'SELECTED_DEVICE',
  SELECTED_DEVICE_ID: 'selectedDeviceId',
  ORGANIZATION_ID: 'organizationId',
  NETWORK_ID: 'networkId',
  DEVICE_TYPES: {
    AP: 'AP',
    PR: 'PR',
    SW: 'SW',
    MHS: 'MHS',
    ORBI: 'ORBI',
    AV: 'AV'
  },

  // Device Models
  TRI_BAND_MODELS: ['WAC540', 'WAC564', 'WAX630'],
  SUPPORTS_6GHZ_MODELS: ['WAX630E', 'WAX638E', 'WBE750', 'WBE758', 'WBE710', 'WBE718'],
  // WBE70XY family models that support antenna switching (Internal/External)
  WBE70XY_MODELS: ['WBE700Y', 'WBE708Y'],

  // Band Keys
  BAND_KEYS: {
    WLAN0: 'wlan0',
    WLAN1: 'wlan1',
    WLAN5_LOW: 'wlan5Low',
    WLAN2: 'wlan2',
    WLAN2_6: 'wlan2_6'
  },

  // Band Labels (non-internationalized)
  BAND_LABELS: {
    wlan0: '2.4 GHz',
    wlan1: '5 GHz',
    wlan5Low: '5 GHz Low',
    wlan2: '5 GHz High',
    wlan2_6: '6 GHz'
  },

  // Band Label Translation Keys
  BAND_LABEL_I18N_KEYS: {
    wlan0: 'band2_4GHz',
    wlan1: 'band5GHz',
    wlan5Low: 'band5GHzLow',
    wlan2: 'band5GHzHigh',
    wlan2_6: 'band6GHz'
  },

  // Network Constants
  VALID_SUBNET_MASKS: [
    '255.255.255.255',
    '255.255.255.254',
    '255.255.255.252',
    '255.255.255.248',
    '255.255.255.240',
    '255.255.255.224',
    '255.255.255.192',
    '255.255.255.128',
    '255.255.255.0',
    '255.255.254.0',
    '255.255.252.0',
    '255.255.248.0',
    '255.255.240.0',
    '255.255.224.0',
    '255.255.192.0',
    '255.255.128.0',
    '255.255.0.0',
    '255.254.0.0',
    '255.252.0.0',
    '255.248.0.0',
    '255.240.0.0',
    '255.224.0.0',
    '255.192.0.0',
    '255.128.0.0',
    '255.0.0.0',
    '254.0.0.0',
    '252.0.0.0',
    '248.0.0.0',
    '240.0.0.0',
    '224.0.0.0',
    '192.0.0.0',
    '128.0.0.0',
    '0.0.0.0'
  ],

  // Subscription Constants
  SUBSCRIPTION: {
    // Number of days before trial ends to show the trial ending banner
    TRIAL_ENDING_BANNER_THRESHOLD_DAYS: 10,
    // PRJCBUGEN-64047: Temporarily hide the LMS partner keys expired global banner until backend calculation is updated.
    SHOW_LMS_PARTNER_KEYS_EXPIRED_BANNER: false
  },

  WEEKDAY_OPTIONS: [
    { value: '1', label: 'S' },
    { value: '2', label: 'M' },
    { value: '3', label: 'T' },
    { value: '4', label: 'W' },
    { value: '5', label: 'TH' },
    { value: '6', label: 'F' },
    { value: '7', label: 'S' }
  ],
};

